function Nav() {
    return (

        <div className="container-fluid">
              <nav class="navbar navbar-expand-lg fixed-top">
        <div class="container-fluid">
        <a className="navbar-brand fw-bold"> <span className="text-warning">QP To Marks</span><span id="darkblue"> Calculator</span></a> 
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item">
                        <a class="nav-link active" href="/">Home</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active" href="https://bykhizershafi.vercel.app/">Contact</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
        </div>
    )
};

export default Nav;
